enum ReviewStatus {
  NONE = 'NONE',
  REQUESTED = 'REQUESTED',
  REVIEWED = 'REVIEWED',
}

export default ReviewStatus;
